import styled from "styled-components";
import colors from "../../../../../../core/styles/colors";

export const GosuslugiHighEducationCardContainer = styled.a`
  box-shadow: 0 0 8px ${colors.gray.gray100};
  width: 100%;
  background: ${colors.white.general};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  text-decoration: none;

  .content {
    position: relative;
    width: calc(100% - 20px);
    margin: 20px 10px 5px 10px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      border-radius: 10px 10px 0 0;
      opacity: 0.2;
      transition: none;
    }
  }

  &:hover {
    img {
      opacity: 0.2;
    }
  }

  .overlayText {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    pointer-events: none;
  }

  .overlayTextContent {
    margin: 0;
    font-family: Gilroy, serif;
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    text-align: center;
    color: ${colors.black.general};
    text-shadow: 0 0 6px ${colors.white.general}, 0 0 4px ${colors.white.general};

    .linkWord {
      color: ${colors.blue.general};
      text-decoration: underline;
    }
  }

  .footer {
    width: calc(100% - 32px);
    padding: 0 16px;
    background: ${colors.black.general};
    border-radius: 0 0 10px 10px;

    h3 {
      padding: 10px 0;
      color: ${colors.white.general};
      text-transform: uppercase;
    }
  }
  @media all and (max-width: 1300px) {
    .overlayTextContent {
      font-size: 10px;
      line-height: 13px;
    }
  }
`;
